import React, { useEffect } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Tooltip, Box } from '@mui/material'

// Centralized lodash imports - much cleaner!
import {
  includes,
  toLower,
  startCase as startcase,
  split,
  replace,
  isEmpty,
  get,
} from '@/utils/lodash'

import { connect } from 'react-redux'
import { NavLink } from 'react-router'

import {
  setSidebarToggle,
  setSidebarToggleMobile,
} from '../../reducers/ThemeOptions'

import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import withSession from '@/housefolios-components/Session/withSession'

import HamburgerButton from '@/layout-components/HamburgerButton'
import {
  sidebarHeaderSx,
  sidebarLogoSx,
  sidebarLogoTextSx,
  sidebarLogoLinkSx,
  sidebarLogoImgSx,
  sidebarLogoSmallImgSx,
  collapseSidebarBtnSx,
  expandSidebarBtnSx,
} from '@/layout-blueprints/chromeComponentSx'

const SidebarHeader = (props) => {
  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile)
  }
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle)
  }
  const {
    sidebarToggleMobile,
    setSidebarToggleMobile,

    sidebarToggle,
    setSidebarToggle,
  } = props

  useEffect(() => {
    if (props.collapsed) {
      setSidebarToggle(true)
    } else {
      setSidebarToggle(false)
    }
  }, [props.collapsed, setSidebarToggle])

  let isMember = false
  let sidebarMemberFullImage = '/images/LeftNavLogo.png'
  let sidebarMemberFullImageStyle = { width: 250, marginRight: 5 }
  let sidebarMemberSmallImage = '/images/LeftNavLogo.png'
  let sidebarMemberSmallImageStyle = { width: 30 }

  if (
    props.session.me.activeOrg.parentCorp &&
    props.session.me.activeOrg.parentCorp.logo
  ) {
    isMember = true
    sidebarMemberFullImage =
      props.session.me.activeOrg.parentCorp.logo.url
    sidebarMemberFullImageStyle = {
      width: 120,
      marginRight: 5,
      marginLeft: 25,
      marginTop: 15,
    }
    sidebarMemberSmallImage =
      props.session.me.activeOrg.parentCorp.logo.url
    sidebarMemberSmallImageStyle = { width: 30 }
  }

  const { affiliate = {} } = props
  if (isEmpty(affiliate)) isMember = false
  else {
    const { sidebar = {} } = affiliate
    isMember = true
    sidebarMemberFullImage =
      get(sidebar, 'sidebarMemberFullImage.0.url') ||
      '/images/defaultSidebarFullLogo.png'
    sidebarMemberFullImageStyle =
      sidebar.sidebarMemberFullImageStyle || {
        width: 120,
        marginRight: 5,
        marginLeft: 25,
        marginTop: 15,
      }
    sidebarMemberSmallImage =
      get(sidebar, 'sidebarMemberSmallImage.0.url') ||
      '/images/defaultSidebarSmallLogo.png'
    sidebarMemberSmallImageStyle =
      sidebar.sidebarMemberSmallImageStyle || { width: 50 }
  }

  if (isMember) {
    if (props?.session?.me?.activeOrg?.member === 'RWN') {
      sidebarMemberFullImage = '/images/YellowRWNLogo.png'
      sidebarMemberFullImageStyle = { width: 250, marginRight: 5 }
      sidebarMemberSmallImage = '/images/SmallRWNLogo.png'
      sidebarMemberSmallImageStyle = { width: 30 }
    }
  }

  return (
    <>
      <Box sx={sidebarHeaderSx} data-hf="sidebar-header">
        <Box sx={{ ...sidebarLogoSx, justifyContent: 'center', flex: 1, minWidth: 0, }} data-hf="sidebar-logo">
          <Box
            component={NavLink}
            id="leftNavHeaderLogo"
            to="/"
            title="Housefolios"
            sx={sidebarLogoLinkSx}
          >
            {isMember && !sidebarToggle ? (
              <Box
                component="img"
                alt="Housefolios"
                src={sidebarMemberFullImage}
                sx={sidebarLogoImgSx}
              />
            ) : (
              <Box
                sx={{
                  backgroundColor: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  maxHeight: '50px',
                }}
              >
                <Box
                  component="img"
                  alt="Housefolios"
                  sx={sidebarLogoSmallImgSx}
                  src={sidebarMemberSmallImage}
                />
              </Box>
            )}
            {!isMember && (
              <Box sx={{ ...sidebarLogoTextSx, display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#fff', marginLeft: '10px', }} data-hf="sidebar-logo-text">
                <span>
                  {startcase(
                    split(
                      replace(
                        props.session.me.subscriptionPlan,
                        '_',
                        '-',
                      ),
                      '-',
                    )[0],
                  )}{' '}
                  Plan
                </span>
                <b>Housefolios</b>
              </Box>
            )}
          </Box>
        </Box>
        {!includes(
          toLower(window.location.pathname),
          'property-details',
        ) && (
          <Tooltip title="Collapse sidebar" placement="right" arrow>
            <Button id="collapseSidebarButton" onClick={toggleSidebar} sx={[{
              py: "0.25rem",
              px: "1.1rem",
              fontSize: "0.875rem",
              lineHeight: 1.5,
            }, collapseSidebarBtnSx]} data-hf="collapse-sidebar-btn">
              <MenuOpenIcon />
            </Button>
          </Tooltip>
        )}
        {!includes(
          toLower(window.location.pathname),
          'property-details',
        ) && (
          <HamburgerButton id="toggleMainNavMobileButton" active={sidebarToggleMobile} mobileOnly onClick={toggleSidebarMobile} data-hf="toggle-mobile-sidebar-btn" />
        )}
        {!includes(
          toLower(window.location.pathname),
          'property-details',
        ) && (
          <Tooltip title="Expand sidebar" placement="right" arrow>
            <Button id="expandSidebarButton" onClick={toggleSidebar} sx={[{
              py: "0.25rem",
              px: "1.1rem",
              fontSize: "0.875rem",
              lineHeight: 1.5,
            }, expandSidebarBtnSx]} data-hf="expand-sidebar-btn">
              <FontAwesomeIcon icon={['fas', 'left-right']} />
            </Button>
          </Tooltip>
        )}
      </Box>
    </>
  )
}

const mapStateToProps = (state) => ({
  sidebarToggle: state.DeprecatedThemeOptions.sidebarToggle,
  sidebarToggleMobile:
    state.DeprecatedThemeOptions.sidebarToggleMobile,
})

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggle: (enable) => dispatch(setSidebarToggle(enable)),
  setSidebarToggleMobile: (enable) =>
    dispatch(setSidebarToggleMobile(enable)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSession(SidebarHeader))
